import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Nav } from "@/components/Nav";
import { Hero } from "@/sections/Hero";
import { About } from "@/sections/About";
import { Carta } from "@/sections/Carta";
import { Preparacion } from "@/sections/Preparacion";
import { Highlights } from "@/sections/Highlights";
import { Gallery } from "@/sections/Gallery";
import { Visit } from "@/sections/Visit";
import { Reserva } from "@/sections/Reserva";
import { Entrada } from "@/sections/Entrada";
import { Footer } from "@/sections/Footer";
import { MenuPage } from "@/sections/MenuPage";
import { LanguageProvider, useLang } from "@/i18n";
import { V2App } from "@/v2/V2App";
import { getRequestedVersion } from "@/lib/version";
import { V1MobileDock } from "@/components/V1MobileDock";

const V1App = () => (
  <div className="v1-app min-h-screen bg-[#2B1E16] antialiased">
    <Nav />
    <main className="v1-main">
      <Hero />
      <About />
      <Carta />
      <Preparacion />
      <Highlights />
      <Gallery />
      <Visit />
      <Reserva />
      <Entrada />
    </main>
    <Footer />
    <V1MobileDock />
  </div>
);

// /carta : page menu du QR code des tables.
const isMenuPage = () => /^\/carta\/?$/.test(window.location.pathname);

const Experience = () => {
  const { lang } = useLang();
  if (isMenuPage()) return <MenuPage />;
  const requestedVersion = getRequestedVersion();
  return requestedVersion === 2 && lang === "es" ? <V2App /> : <V1App />;
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <Experience />
    </LanguageProvider>
  );
}

export default App;
